import { useTranslation } from 'react-i18next';
import Storage from '../utils/storageES.js';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);

    // Save to user settings
    const settings = Storage.getSettings();
    Storage.saveSettings({ ...settings, language: lng });

    console.log(`🌍 Language changed to: ${lng}`);
  };

  const languages = [
    { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
    { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
    { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' }
  ];

  return (
    <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
      padding: '8px',
      background: 'rgba(255, 255, 255, 0.9)',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      {languages.map(lang => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          style={{
            padding: '8px 12px',
            borderRadius: '8px',
            border: 'none',
            background: i18n.language === lang.code ? '#5B8FA8' : 'transparent',
            color: i18n.language === lang.code ? 'white' : '#8B7355',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
          title={lang.name}
        >
          <span>{lang.flag}</span>
          <span>{lang.label}</span>
        </button>
      ))}
    </div>
  );
}
